function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { loadModule, logger, fill, arrayify, isThenable } from '@sentry/utils';
import { shouldDisableAutoInstrumentation } from './utils/node-utils.js';
/** Tracing integration for Apollo */

var Apollo = /*#__PURE__*/function () {
  /**
   * @inheritDoc
   */
  function Apollo() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      useNestjs: false
    };

    _classCallCheck(this, Apollo);

    Apollo.prototype.__init.call(this);

    this._useNest = !!options.useNestjs;
  }
  /** @inheritdoc */


  _createClass(Apollo, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = Apollo.id;
    }
  }, {
    key: "loadDependency",
    value: function loadDependency() {
      if (this._useNest) {
        this._module = this._module || loadModule('@nestjs/graphql');
      } else {
        this._module = this._module || loadModule('apollo-server-core');
      }

      return this._module;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      if (shouldDisableAutoInstrumentation(getCurrentHub)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('Apollo Integration is skipped because of instrumenter configuration.');
        return;
      }

      if (this._useNest) {
        var pkg = this.loadDependency();

        if (!pkg) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Apollo-NestJS Integration was unable to require @nestjs/graphql package.');
          return;
        }
        /**
         * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
         */


        fill(pkg.GraphQLFactory.prototype, 'mergeWithSchema', function (orig) {
          return function () {
            fill(this.resolversExplorerService, 'explore', function (orig) {
              return function () {
                var resolvers = arrayify(orig.call(this));
                var instrumentedResolvers = instrumentResolvers(resolvers, getCurrentHub);
                return instrumentedResolvers;
              };
            });

            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return orig.call.apply(orig, [this].concat(args));
          };
        });
      } else {
        var _pkg = this.loadDependency();

        if (!_pkg) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Apollo Integration was unable to require apollo-server-core package.');
          return;
        }
        /**
         * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
         */


        fill(_pkg.ApolloServerBase.prototype, 'constructSchema', function (orig) {
          return function () {
            if (!this.config.resolvers) {
              if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) {
                if (this.config.schema) {
                  logger.warn('Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.' + 'If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.');
                  logger.warn();
                } else if (this.config.modules) {
                  logger.warn('Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.');
                }

                logger.error('Skipping tracing as no resolvers found on the `ApolloServer` instance.');
              }

              return orig.call(this);
            }

            var resolvers = arrayify(this.config.resolvers);
            this.config.resolvers = instrumentResolvers(resolvers, getCurrentHub);
            return orig.call(this);
          };
        });
      }
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'Apollo';
    }
  }]);

  return Apollo;
}();

Apollo.__initStatic();

function instrumentResolvers(resolvers, getCurrentHub) {
  return resolvers.map(function (model) {
    Object.keys(model).forEach(function (resolverGroupName) {
      Object.keys(model[resolverGroupName]).forEach(function (resolverName) {
        if (typeof model[resolverGroupName][resolverName] !== 'function') {
          return;
        }

        wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
      });
    });
    return model;
  });
}
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */


function wrapResolver(model, resolverGroupName, resolverName, getCurrentHub) {
  fill(model[resolverGroupName], resolverName, function (orig) {
    return function () {
      var scope = getCurrentHub().getScope();

      var parentSpan = _optionalChain([scope, 'optionalAccess', function (_2) {
        return _2.getSpan;
      }, 'call', function (_3) {
        return _3();
      }]);

      var span = _optionalChain([parentSpan, 'optionalAccess', function (_4) {
        return _4.startChild;
      }, 'call', function (_5) {
        return _5({
          description: "".concat(resolverGroupName, ".").concat(resolverName),
          op: 'graphql.resolve'
        });
      }]);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var rv = orig.call.apply(orig, [this].concat(args));

      if (isThenable(rv)) {
        return rv.then(function (res) {
          _optionalChain([span, 'optionalAccess', function (_6) {
            return _6.finish;
          }, 'call', function (_7) {
            return _7();
          }]);

          return res;
        });
      }

      _optionalChain([span, 'optionalAccess', function (_8) {
        return _8.finish;
      }, 'call', function (_9) {
        return _9();
      }]);

      return rv;
    };
  });
}

export { Apollo };